const APP_LINK_HOSTS = new Set([
  'app.mermapp.com',
  'warm-tokenizer-365109.web.app',
  'mer-mapp.vercel.app',
]);

export function appRouteFromUrlOpen(url: string): string | null {
  let parsedUrl: URL;
  try {
    parsedUrl = new URL(url);
  } catch (error) {
    return null;
  }

  if (!APP_LINK_HOSTS.has(parsedUrl.hostname)) {
    return null;
  }

  const path = parsedUrl.pathname || '/';
  const search = parsedUrl.search || '';
  const hash = parsedUrl.hash || '';

  return `${path}${search}${hash}`;
}
